import { useQuery } from '@tanstack/react-query'

import { FetchLocations } from '@/services/LocationService'

/**
 * Every location an organization has, each with its full detail.
 *
 * Keyed to match what `useCreateLocation` invalidates, so adding a location
 * refreshes this without the caller arranging it.
 */
export const useLocations = (orgId: string) => {
  return useQuery({
    queryKey: ['locations', orgId],
    queryFn: () => FetchLocations(orgId),
    enabled: orgId !== '',
  })
}
